import {
  IconButton,
  Link,
  IconButtonProps,
  HbTooltip,
} from '@cdl/heartbeat-react';
import { useEffect, useRef } from 'react';

interface Props extends IconButtonProps {
  label: string;
  href?: string;
  isActive?: boolean;
  isTooltipOpen?: boolean;
}

export const ToolButton: React.FC<Props> = ({
  label,
  href,
  isActive,
  isTooltipOpen,
  ...props
}) => {
  const ref = useRef<HTMLButtonElement>(null);
  const icon = (
    <IconButton
      ref={ref}
      variant='tertiary'
      size='sm'
      isActive={isActive}
      _active={{
        color: 'primary.500',
      }}
      {...props}
    />
  );

  useEffect(() => {
    if (!isActive) {
      ref.current?.blur();
    }
  }, [isActive]);

  return (
    <HbTooltip
      label={label}
      placement='top'
      hasArrow
      {...(isTooltipOpen != null && { isOpen: isTooltipOpen })}
    >
      {href ? (
        <Link href={href} target='_blank'>
          {icon}
        </Link>
      ) : (
        icon
      )}
    </HbTooltip>
  );
};
